import request from '../../utils/request';

export async function getDoubaoPromptTemplateContentRequest(params) {
  return request({
    url: 'doubao/prompt/template/getContent',
    method: 'get',
    headers: 'json',
    params,
  });
}
export async function updateDoubaoPromptTemplateContentRequest(params) {
  return request({
    url: 'doubao/prompt/template/updateContent',
    method: 'post',
    headers: 'json',
    params,
  });
}

export async function getProductCorrectionDictPageRequest(params) {
  return request({
    url: 'product/correction/dict/page',
    method: 'post',
    headers: 'json',
    params,
  });
}

export async function addProductCorrectionDictRequest(params) {
  return request({
    url: 'product/correction/dict/add',
    method: 'post',
    headers: 'json',
    params,
  });
}

export async function updateProductCorrectionDictRequest(params) {
  return request({
    url: 'product/correction/dict/update',
    method: 'post',
    headers: 'json',
    params,
  });
}

export async function deleteProductCorrectionDictRequest(id) {
  return request({
    url: `product/correction/dict/delete?id=${id}`,
    method: 'delete',
    headers: 'json',
  });
}

export async function getLargeModelLogPageRequest(params) {
  return request({
    url: 'ai/recognition/log/page',
    method: 'post',
    headers: 'json',
    params,
  });
}
